/* import __COLOCATED_TEMPLATE__ from './ftw-hex.hbs'; */
import Component from '@glimmer/component';
import { padLeft } from '../utils';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type CircuitService from '../services/circuit';
import { ProductRow } from '../services/state';

interface FTWHexInputSignature {
  Args: {
    label: string;
    isExceededFtw?: boolean;
    ftwChanged: (value: number) => void;
  };
}
export default class FTWHexInput extends Component<FTWHexInputSignature> {
  @service declare circuit: CircuitService;

  get ftwDisplay() {
    let result = '';
    const part = this.circuit.partData as ProductRow;
    // If we have an error that involves an error message, blank the value out.
    // Otherwise, show the value.
    if (!this.circuit.hasCriticalError && !this.args.isExceededFtw) {
      result = isNaN(this.circuit.ftw) ? '' : padLeft(this.circuit.ftwHex, part.tuningWordWidth / 4, '0');
    }
    return result;
  }
  @action localFtwChanged(event: Event) {
    const target = event.target as HTMLInputElement;
    const isValidHex = /^[0-9a-fA-F]+$/.test(target.value);
    if (this.ftwDisplay !== target.value) {
      // If we can parse the value, parse it and hand it off to the panel to figure out if the number makes sense
      if (isValidHex) {
        this.args.ftwChanged(parseInt(target.value, 16));
      } else {
        // Fall back to the most recent successfully-parsed value we can use
        // even if it turned out subsequently to be invalid for other reasons
        if (this.circuit.uncommittedFtwValue !== null) {
          this.args.ftwChanged(this.circuit.uncommittedFtwValue);
        } else {
          this.args.ftwChanged(this.circuit.ftw);
        }
      }
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    FtwHex: typeof FTWHexInput;
  }
}
